import React, { useId } from 'react';

// The Cadenza mark: a spoken melody line that resolves on a final note.
// Geometry is the master in brand/cadenza/mark.svg — keep them identical.
export const CadenzaMark = ({ size = 28, className = '', mono = false }) => {
  const id = useId().replace(/:/g, '');
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" className={className} aria-hidden="true">
      <defs>
        <linearGradient id={`czg-${id}`} x1="7" y1="0" x2="51" y2="0" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#3387FF" />
          <stop offset="1" stopColor="#5EE0FF" />
        </linearGradient>
      </defs>
      <path
        d="M7 40 C 14 40 17 22 26 22 C 35 22 36 40 44 40 C 48 40 49.5 37 50.5 35"
        fill="none"
        stroke={mono ? 'currentColor' : `url(#czg-${id})`}
        strokeWidth="7"
        strokeLinecap="round"
      />
      <circle cx="55" cy="22" r="5.6" fill={mono ? 'currentColor' : '#FF6B4A'} />
    </svg>
  );
};

const Logo = ({ size = 28, className = '' }) => (
  <span className={`inline-flex items-center gap-2 ${className}`}>
    <CadenzaMark size={size} />
    <span className="text-[19px] font-semibold tracking-[-0.04em] text-white">cadenza</span>
  </span>
);

export default Logo;
